import { LoadingLayout } from 'components';
import { usePageTitleTranslation } from 'libs/navigation';

import { useCreateOperation } from '../hooks';
import { CreateOperationView } from '../views';

export const CreateOperationContainer = () => {
  const {
    initialValues,
    breadcrumbsTitles,
    submitLoading,
    brokerTimezoneOffset,
    canChangeClientAndOrder,
    loading,
    onSubmit,
    onBack,
  } = useCreateOperation();

  usePageTitleTranslation('operation.createOperation.title');

  if (loading) {
    return <LoadingLayout />;
  }

  return (
    <CreateOperationView
      breadcrumbsTitles={breadcrumbsTitles}
      brokerTimezoneOffset={brokerTimezoneOffset}
      canChangeClientAndOrder={canChangeClientAndOrder}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onBack={onBack}
      onSubmit={onSubmit}
    />
  );
};
